var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3077 11.0769V18C20.3077 18.25 20.2163 18.4663 20.0336 18.649C19.8509 18.8317 19.6346 18.9231 19.3846 18.9231H13.8461V13.3846H10.1538V18.9231H4.61537C4.36537 18.9231 4.14902 18.8317 3.96633 18.649C3.78364 18.4663 3.69229 18.25 3.69229 18V11.0769C3.69229 11.0673 3.6947 11.0529 3.6995 11.0336C3.70431 11.0144 3.70672 11 3.70672 10.9904L12 4.15384L20.2933 10.9904C20.3029 11.0096 20.3077 11.0385 20.3077 11.0769ZM23.524 10.0817L22.6298 11.149C22.5529 11.2356 22.4519 11.2885 22.3269 11.3077H22.2836C22.1586 11.3077 22.0577 11.274 21.9808 11.2067L12 2.8846L2.01922 11.2067C1.90383 11.2836 1.78845 11.3173 1.67306 11.3077C1.54806 11.2885 1.4471 11.2356 1.37018 11.149L0.475947 10.0817C0.399024 9.98557 0.36537 9.87259 0.374985 9.74278C0.384601 9.61297 0.437485 9.5096 0.533639 9.43268L10.9038 0.793259C11.2115 0.543259 11.5769 0.418259 12 0.418259C12.4231 0.418259 12.7884 0.543259 13.0961 0.793259L16.6154 3.73557V0.923066C16.6154 0.788451 16.6586 0.677874 16.7452 0.591336C16.8317 0.504797 16.9423 0.461528 17.0769 0.461528H19.8461C19.9808 0.461528 20.0913 0.504797 20.1779 0.591336C20.2644 0.677874 20.3077 0.788451 20.3077 0.923066V6.80768L23.4663 9.43268C23.5625 9.5096 23.6154 9.61297 23.625 9.74278C23.6346 9.87259 23.6009 9.98557 23.524 10.0817Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18.9231,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaHome);
export default __webpack_public_path__ + "static/media/fa_home.efee2baf4d9d008b4fbeeedb5761dd96.svg";
export { ForwardRef as ReactComponent };